var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _vm.displayEditIdentifiants
        ? _c("edit-identifiants", {
            staticClass: "m-auto w-100",
            attrs: { row_en: _vm.selectedEnduser },
            on: {
              closeEditIdentifiants: function($event) {
                return _vm.displayEditId()
              }
            }
          })
        : _vm._e(),
      _vm._l(_vm.getEndusersWithBoxes, function(box, indexBox) {
        return _c("div", { key: indexBox }, [
          _c("h3", [_vm._v(" Kit Emotivi / " + _vm._s(box.en_fullname) + " ")]),
          _vm._m(0, true),
          _c("div", { staticClass: "alert alert-light" }, [
            _vm._v(
              " Commandée le : " +
                _vm._s(
                  _vm.$moment(box.createdAt).format("DD/MM/YYYY [à] HH:mm")
                )
            ),
            _c("br"),
            _vm._v(
              " Version logiciel : " +
                _vm._s(box.bo_id.bo_hardwareinfo.appemotivi_version)
            ),
            _c("br"),
            _vm._v(
              " Adresse MAC Ethernet : " +
                _vm._s(box.bo_id.bo_hardwareinfo.ethernet_mac_address)
            ),
            _c("br"),
            _vm._v(
              " Adresse MAC WIFI : " +
                _vm._s(box.bo_id.bo_hardwareinfo.wifi_mac_address) +
                " "
            )
          ]),
          _c("div", { staticClass: "d-flex flex-row w-100 mb-2" }, [
            _c("h4", { staticClass: "flex-grow-1 mb-0" }, [
              _vm._v(" Informations de connexion ")
            ]),
            box.bo_id
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.displayEditId(box)
                      }
                    }
                  },
                  [_vm._v(" Modifier ")]
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "alert alert-light" }, [
            _vm._v(" identifiant : " + _vm._s(box.en_webapp_login)),
            _c("br"),
            _vm._v(" mot de passe : " + _vm._s(box.en_webapp_password)),
            _c("br"),
            _vm._v(" code administrateur : " + _vm._s(box.en_admincode)),
            _c("br"),
            box.bo_id
              ? _c("span", [
                  _vm._v(" application Emotivi : "),
                  _c(
                    "a",
                    {
                      staticClass: "link",
                      on: {
                        click: function($event) {
                          return _vm.launchWebapp(box)
                        }
                      }
                    },
                    [_vm._v("se connecter")]
                  )
                ])
              : _vm._e()
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex flex-row w-100 mb-2" }, [
      _c("h4", { staticClass: "flex-grow-1 mb-0" }, [
        _vm._v(" Informations générales ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }